// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__KcrRk","tab":"TabsNew_tab__L15mC"};